import { CCardBody, CCardText } from '@coreui/react';
import { useEffect, useState } from 'react';
import GridTable from 'src/components/GridTable';
import HasRole from 'src/components/auth/HasRole';
import { ROLES } from 'src/constants';
import { format_money } from 'src/helpers';
import StatisticService from 'src/services/statistic.service';
import notify from 'src/utils/notify';
import { number_format } from 'src/utils/number';

const StatisticByCountry = ({ queryParams }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({
        list: [],
        total: {
            total_views: 0,
            total_money: 0,
        },
    });
    useEffect(() => {
        fetchData();
    }, [queryParams]);

    const setting = [
        {
            label: 'Top',
            render: ({ index }) => {
                return index + 1;
            },
        },
        {
            label: 'Country',
            render: ({ item }) => {
                return (
                    <>
                        {item.country_name} <img className="mx-2" height={15} src={item.country_img} alt="" />
                    </>
                );
            },
        },
        {
            label: 'Impressions',
            column: 'total_views',
            render: ({ item, data }) => {
                const total_views = data.total.total_views;
                const ratio = total_views > 0 ? ((+item.total_views / total_views) * 100).toFixed(2) : 0;
                return number_format(item.total_views) + ` (${ratio} %)`;
            },
        },
        {
            label: 'Total Money',
            column: 'total_money',
            render: ({ item, data }) => {
                const total_money = data.total.total_money;
                const ratio = total_money > 0 ? ((+item.total_money / total_money) * 100).toFixed(2) : 0;
                return number_format(item.total_money);
            },
            roles: [ROLES.ROLE_SUPER],
        },
        {
            label: 'RPM',
            column: 'rpm',
            roles: [ROLES.ROLE_SUPER],
        },
    ];

    function fetchData() {
        setIsLoading(true);
        StatisticService.byCountry(queryParams)
            .then((data) => {
                setData(data);
            })
            .catch(notify.response)
            .finally(() => setIsLoading(false));
    }

    return (
        <>
            <CCardBody>
                <CCardText>Impressions {number_format(data.total.total_views)}</CCardText>
                <HasRole roles={[ROLES.ROLE_SUPER]}>
                    <CCardText>Total Money {format_money(data.total.total_money)}</CCardText>
                </HasRole>
            </CCardBody>
            <GridTable
                setting={setting}
                data={data}
                pagination={false}
                extraData={queryParams}
                isLoading={isLoading}
                showLoading={true}
            />
        </>
    );
};

export default StatisticByCountry;
